import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedUserListComponent } from './shared-user-list.component';
import { SharedLayoutModule } from '../../shared-layout.module';
import { ControlDisabledDirectiveModule } from 'src/app/libs/ui/directives/control-disabled/control-disabled-directive.module';
import { RouterModule } from '@angular/router';
import { ParsedTimeModule } from 'src/app/libs/ui/pipes/parsed-time/parsed-time.module';
import { ParsedDateTimeModule } from 'src/app/libs/ui/pipes/parsed-date-time/parsed-date-time.module';
import { ProfilePictureModule } from '../profile-picture/profile-picture.module';
import { WithTooltipModule } from '../with-tooltip/with-tooltip.module';
import { HideAccessModule } from 'src/app/libs/ui/directives/hide-access/hide-access.module';
import { TranslateModule } from '@ngx-translate/core';
import { LocalizationService } from 'src/app/shared/services/localization.service';

@NgModule({
  declarations: [SharedUserListComponent],
  imports: [
    CommonModule,
    RouterModule,
    SharedLayoutModule,
    WithTooltipModule,
    ControlDisabledDirectiveModule,
    ParsedTimeModule,
    ParsedDateTimeModule,
    ProfilePictureModule,
    HideAccessModule,
    TranslateModule
  ],
  exports: [SharedUserListComponent],
  providers: [
    LocalizationService,
    TranslateModule
  ],
})
export class SharedUserListModule {}
